// @flow
import { createSelector } from 'reselect';
import type { StateType } from './types';

export const getAcquireDevices = (state: { acquireDevices: StateType }): StateType => state.acquireDevices;

export const getAcquiredDevices = createSelector([getAcquireDevices], acquireDevices => acquireDevices.devices);

export const errorsSelector = ({ acquireDevices }: { acquireDevices: StateType }): number => acquireDevices.errors;

export const getInstallInProgress = createSelector(
    [getAcquireDevices],
    acquireDevices => acquireDevices.installInProgress
);

export const getPlacementAdvice = createSelector(getAcquireDevices, acquireDevices => acquireDevices.placementAdvice);



// WEBPACK FOOTER //
// ./src/core/state/acquire-devices/selectors.js